import { menuGroup, menuItem } from "modules/helpers";

// components
import VirtualizedRow from "./VirtualizedRow.doc";

const components = [
  menuItem("<VirtualizedRow/>", "virtualized-row", VirtualizedRow),
];

// hooks
import UseDebounce from "./UseDebounce.doc";
import UseDebouncedState from "./UseDebouncedState.doc";
import UseDebouncedValue from "./UseDebouncedValue.doc";
import UseElementVisibility from "./UseElementVisibility.doc";
import UsePreviousValue from "./UsePreviousValue.doc";

const hooks = [
  menuItem("useDebounce", "use-debounce", UseDebounce),
  menuItem("useDebouncedState", "use-debounced-state", UseDebouncedState),
  menuItem("useDebouncedValue", "use-debounced-value", UseDebouncedValue),
  menuItem(
    "useElementVisibility",
    "use-element-visibility",
    UseElementVisibility
  ),
  menuItem("usePreviousValue", "use-previous-value", UsePreviousValue),
];

export default [
  menuGroup("Components", "components", components),
  menuGroup("Hooks", "hooks", hooks),
];
